import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/col/Col.less');
const cx = classnames.bind(styles);

const DEFAULT_GRID_SIZE = 4;

export interface IColProps
{
    size?:number;
    gridSize?:number;
    className?:string;
    centerVertically?:boolean;
    centerHorizontally?:boolean;
}

export class Col extends React.Component<IColProps>
{
    public render():JSX.Element
    {
        const {
            children,
            size = 1,
            gridSize = DEFAULT_GRID_SIZE,
            className,
            centerVertically = false,
            centerHorizontally = false,
            ...restProps
        } = this.props;

        return (
            <div
                className={cx('base', className, {centerVertically, centerHorizontally})}
                style={{flexBasis: (size / gridSize * 100) + '%'}}
                {...restProps}
            >
                {children}
            </div>
        );
    }
}
